export const STOP_CONFIRMATION = "STOP MIRA";
export const RESUME_CONFIRMATION = "RESUME MIRA";

/** The button remains inert until the incident reason and typed confirmation
 * prove the operator intends this exact platform-wide action. */
export function canSubmitPlatformAction({
  killed,
  reason,
  confirmation,
  busy,
}: {
  killed: boolean;
  reason: string;
  confirmation: string;
  busy: boolean;
}): boolean {
  const trimmedReason = reason.trim();
  return (
    confirmation === (killed ? RESUME_CONFIRMATION : STOP_CONFIRMATION) &&
    (killed || (trimmedReason.length >= 5 && trimmedReason.length <= 500)) &&
    !busy
  );
}
